import { axiosClient } from '../../../../services/axiosInstance'
import { OrderForm } from '../../entity/orderForm'
import { storage } from '../utils/storage'

const { getItem, setItem } = storage()

const isBrowser = typeof window !== `undefined`

export const getOrderForm = async (
  paramOrderFormId?: string
): Promise<OrderForm> => {
  if (!isBrowser) {
    return {
      orderFormId: '',
      items: [],
      messages: [],
      totalizers: {},
      clientProfileData: null,
      customData: null,
      shippingData: {},
      loggedIn: false,
      clientPreferencesData: {},
      paymentData: {},
      marketingData: {},
      sellers: [],
    }
  }

  const storageOrderFormId = isBrowser ? getItem('orderFormId') : null

  if (paramOrderFormId) {
    const paramOrderForm = await requestOrderForm(paramOrderFormId)

    if (paramOrderForm) {
      setItem('orderFormId', paramOrderForm.orderFormId)

      return new OrderForm(paramOrderForm)
    }
  }

  if (storageOrderFormId) {
    const storageOrderForm = await requestOrderForm(storageOrderFormId)

    if (storageOrderForm) {
      return new OrderForm(storageOrderForm)
    }
  }

  const newOrderForm = await createNewOrderForm()

  setItem('orderFormId', newOrderForm.orderFormId)

  return new OrderForm(newOrderForm)
}

const createNewOrderForm = async () => {
  return axiosClient.get('/api/checkout/orderForm').then((res) => res.data)
}

const requestOrderForm = async (orderFormId: string) => {
  return axiosClient
    .get(`/api/checkout/orderForm/${orderFormId}`)
    .then((res) => res.data)
    .catch(() => null)
}
